export const CompanyData = [
  // {
  //   image: "images/companies/agrimitra_logo.jpg",
  //   title: "agriMitra Plug-In LLP",
  //   description1: "Platform for Agriculture 4.0 & 5.0",
  //   description2: " ” Internet Agriculture “",
  //   website: "agrimitra.com",
  //   mail: "callerinfoid@gmail.com",
  //   mobile: "+91 9886060490",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  {
    image: "images/companies/ahava_solutions.jpg",
    title: "Ahava Solutions LLP",
    description1:
      "Founded in 2023 by Rushiraj Deshpande and Rahul Patel, Ahava Solutions LLP is a Belagavi-based finance KPO offering end-to-end finance and accounting services.",
    description2:
      "We support businesses across India and Africa with real-time collaboration, fast turnarounds, and high-quality outcomes.",
    website: "www.edhassolutions.com",
  },
  {
    image: "images/companies/Ajinkya_Logo.png",
    title: "Ajinkya Technologies",
    description1:
      "Established in 2019 and headquartered in Belagavi, Ajinkya Technologies drives industrial innovation with smart, scalable, and sustainable engineering solutions.",
    description2:
      "With offices in Bangalore and Pune, and clients across Asia, the US, and Germany, we specialize in manufacturing, water treatment, and automation. ",
    description3:
      "Our industry-first platforms—ranging from traceability to SCADA—are reliable, agile, and integration-focused. Trusted by 500+ clients including JSW and Hindalco, we deliver impactful digital transformation.",
    website: "ajinkyatechnologies.in",
  },
  {
    image: "images/companies/ajr_curevibes.jpg",
    title: "AJR Curevibes Pvt Ltd",
    description1:
      "Founded in 2024 by Dr. Akash Gadgade and team, AJR Curevibes is redefining clinical education and healthcare innovation in India.",
    description2:
      "Headquartered in Bengaluru with a strong presence in Belagavi, we bridge the gap between medical education and real-world practice.",
    description3:
      "With collaborations like Tata 1mg, we focus on impactful, affordable, and accessible healthcare learning and innovation support.",
    website: "ajrcurevibes@gmail.com",
    // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  },
  {
    image: "images/companies/akxatech.jpg",
    title: "AKXA TECH Pvt Ltd",
    description1:
      "Founded in 2016 by Dr. Raghuraj K. Rao, AKXA Tech is a deep-tech industrial analytics company recognized by Startup India and incubated at IIT Madras.",
    description2:
      "Headquartered in Shinoli, Maharashtra, with a strong engineering base in Belagavi, we serve clients across 13 countries. Our AI/ML-powered tools support global manufacturers in enhancing operational efficiency and decision-making.",
    website: "www.akxatech.com",
    // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  },
  {
    image: "images/companies/all_about_belgaum_logo.png",
    title: "All About Belgaum",
    description1:
      "All About Belgaum is the wonderful task of scripting the Better of Belagavi in the Best way.",
    website: "allaboutbelgaum.com",
    // mail: "uday@allaboutbelagaum.com",
    // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  },
  {
    image: "images/companies/alphasure_logo.jpg",
    title: "Alphasure Accountants Pvt Ltd",
    description1:
      "Founded in 2015 by Onkar Marathe, Alphasure is a Belagavi-based financial services firm with a growing presence in Pune, the USA, Canada, Dubai, and the UK.",
    description2:
      "We specialize in comprehensive accounting and finance controller services, combining technology with expertise to help businesses stay compliant, agile, and financially sound.",
    website: "www.alphasure.in ",
  },
  {
    image: "images/companies/AnexGATE_Logo.jpeg",
    title: "AnexGate",
    description1:
      "Established in 2015 in Belagavi, AnexGATE is a “Make in India” cybersecurity company focused on developing affordable, enterprise-grade network security products tailored for Indian conditions.",
    description2:
      "Our solutions serve sectors like healthcare, education, manufacturing, logistics, and banking.",
    website: "anexgate.com",
  },
  // {
  //   image: "images/companies/bitjini_logo.jpg",
  //   title: "Bitjini",
  //   description2:
  //     "Bitjini Apps and More is an Information Technology Solutions providing company situated in Belagavi, India. We focus on Mobile Applications, Web Applications, and a multitude of solutions that enables a business to operate more efficiently and profitably. We work closely with individuals with business ideas and startups to build their products and help them scale up, through quality, performance, and innovation, employing best-of-breed practices and technical wisdom to deliver a complete collaborative business experience.",
  //   website: "bitjini.net",
  //   mail: "contact@bitjini.net",
  //   mobile: "+91 8880374442",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  {
    image: "images/companies/btp_logo.png",
    title: "Btp Infoserve Pvt Ltds",
    description1:
      "Established in 2003 by Tushar Patil, BTP Infoserve is North Karnataka’s first and largest healthcare-focused BPO, headquartered in Belagavi.",
    description2:
      "With 200+ professionals, we specialize in ambulance billing and medical claims processing for North American clients, offering compliance-driven, high-accuracy results.",
    website: " btp-i.com",
    // mail: "btpi@btp-i.com",
  },
  // {
  //   image: "images/companies/deltasys_logo.png",
  //   title: "DELTASYS E FORMING",
  //   description1:
  //     "DELTASYS E FORMING Develop and manufacture Large Format 3D printing machines. We make printers which can make parts in Polymers, Composites and Concretes.",
  //   website: "3deltasys.com",
  //   mail: "info@3deltasys.com",
  //   mobile: "+91 8050583644",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  {
    image: "images/companies/Dattamsh_logo.png",
    title: "Dattamsh Edtech LLP",
    description1:
      "Founded in 2012 by Chetana Sarang, Dattamsh Edtech is a Belagavi-based firm focused on AI and Data Science education.",
    description2:
      "Incubated at KLS IMER, we empower students, teachers, and MSMEs with future-ready skills through workshops, textbooks, and corporate training.",
    description3:
      "Our NCERT-appreciated school textbooks and partnerships with institutions like GIT and Indus Altum reflect our commitment to quality education.",
    website: "www.dattamsh.com",
  },
  {
    image: "images/companies/deltasys_eforming.png",
    title: "Deltasys E-Forming ",
    description1:
      "Founded in 2018 by Virendra Kadam, Deltasys E-Forming is a Belagavi-based deep-tech company pioneering advanced manufacturing solutions.",
    description2:
      "We specialize in precision-built 3D printing machines and 5-axis CNC routers for foundries, composites, and sustainable construction. Recognized by ISO TUV SUD, NSIC, and featured in Elevate & Beyond Bangalore, we serve clients across APAC and Europe.",
    website: "www.deltasys.in",
  },
  {
    image: "images/companies/desillm.png",
    title: "DESILLM Private Limited",
    description1:
      "Founded in 2024 by Kawal Arora and Dr. Savita Bastawadi, DESILLM is a Belagavi-based generative AI company on a mission to revolutionize traditional knowledge systems.",
    description2:
      "From Ayurveda to cultural heritage, we build AI platforms that make ancient wisdom digitally accessible, scalable, and interactive.",
    website: "www.desillm.com",
  },
  {
    image: "images/companies/doortaq.jpeg",
    title: "DoorTaq Technologies Pvt Ltd",
    description1:
      "Founded in 2020 by Rajiv Raykar and Abhijit Shivayogimath, DoorTaq is a Belagavi-based hyperlocal commerce enabler, transforming how Belagavi shops, eats, and accesses services.",
    description2:
      "We aim to be the go-to local delivery platform and a catalyst for digital growth for local businesses.",
    website: "www.doortaq.com",
  },
  {
    image: "images/companies/ecobillz_logo.png",
    title: "Ecobillz Private Limited",
    description1:
      "Founded in 2016 by Ameet Patil (CEO) and Nitesh Rathore (CMO), Ecobillz is a Belagavi-based SaaS company revolutionizing document management in the hospitality industry. ",
    description2:
      "We offer AI-driven digitization solutions to help hotels and restaurants automate operations, enhance guest experiences, and achieve sustainability goals by going paperless. We serve clients in India, the UAE, and the UK.",
    website: "ecobillz.com",
  },
  {
    image: "images/companies/rednerds_logo.svg",
    title: "Evobi Automations Pvt. Ltd.",
    description1:
      "Founded in 2012 and headquartered in Bengaluru with a strong presence in Belagavi through VTU’s VRIF incubation, Evobi Automations is a full-stack product company specializing in educational robotics and electronics product development.",
    description2:
      " We blend design, hardware, software, and cloud technologies to build innovative, scalable tech solutions. Our award-winning products have earned recognition, including the Red Dot Design Award (2023), India Design Mark (2019), and Good Design Award (2019).",
    website: "therednerds.com",
  },
  {
    image: "images/companies/enerzi_logo.jpg",
    title: "ENERZI MICROWAVE SYSTEMS PRIVATE LIMITED",
    description2:
      "Enerzi Microwave Systems Pvt. Ltd. (EMSPL) was incorporated in August 2007. The company has registered with all the essential registrations to carryout business nationally and internationally. EMSPL has developed many products in the field of Microwave Heating over a period of time and has achieved expertise in this field.",
    website: "ENERZI.CO",
    // mail: "SALES@ENERZI.CO",
    // mobile: "+91 9886772784",
    // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  },
  // {
  //   image: "images/companies/FAAST_Logo.png",
  //   title: "FAAST Networks",
  //   description1:
  //     "Fiber And AirSpeed Technology, FAAST in short, was founded in 2015 in Belagavi due to Lack of high speed reliable Internet connectivity options in the City.",
  //   website: "faast.in",
  //   mail: "internet@faast.in",
  //   mobile: "+91 8800755655",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  {
    image: "images/companies/FIS_New_logo.png",
    title: "Fortune Infoserveindia Pvt Ltd",
    description1:
      "Founded in 2012 by Praveen Bangodi, Fortune Infoserve is a Belagavi-based SaaS company specializing in core banking software for credit cooperative institutions.",
    description2:
      "With a strong presence in Karnataka and expanding across India, we provide digital capabilities tailored to the needs of small and medium financial institutions. Our solutions, trusted by many institutions, enable financial digitization and automation.",
    description3:
      "We are empaneled by the Karnataka State Souharda Federal Cooperative, emphasizing the trust we’ve built in the cooperative banking space.",
    website: "fortuneinfoserve.com",
  },
  {
    image: "images/companies/innovv8.png",
    title: "iNNOVV8 Infinite Solutions",
    description1:
      "Established in 2022, iNNOVV8 is an IT products company based in Khade Bazaar, Belagavi, with over 25 years of experience in the IT hardware industry.",
    description2:
      "We specialize in providing high-performance hardware solutions tailored for industrial and enterprise environments across Karnataka, focusing on quality, availability, and exceptional after-sales support.",
    website: "innovv8.com",
  },
  // {
  //   image: "images/companies/informant_logo.png",
  //   title: "Informant Networks",
  //   description1:
  //     "Cyber security company building UTMs, SDWAN Routers, and Edge Connectivity appliances. We offer network security and secure connectivity solutions to our customers. In addition to the above, we also consult and provide services for organizations looking to improve their security posture.",
  //   website: "informantnetworks.com",
  //   mail: "info@informantnetworks.com",
  //   mobile: "+91 8762362577",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  // {
  //   image: "images/companies/ipfy-tm-blue-R_logo.png",
  //   title: "IP-FY",
  //   description2:
  //     "We are a purpose-driven brand of technology professionals who understand and know how to apply intellectual property (IP) laws to safeguard your creations of mind which are in the form of ideas, inventions and innovations. ",
  //   description3:
  //     "We can advise and provide consulting services on Patents, Trademarks, IP Due Diligence, IP Litigation and Open Source Legal Compliance.",
  //   website: "https://ip-fy.com/",
  //   mail: "hello@ip-fy.com",
  //   mobile: "+91 9741950883",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  {
    image: "images/companies/malenadu_naturals.png",
    title: "Malenadu Natural Produce",
    description1:
      "Founded in 2025 and headquartered in Honavar, Uttara Kannada, Malenadu Natural Producer Company connects conscious consumers with authentic, lab-tested natural produce.",
    description2:
      "Rooted in the Western Ghats, we ensure fair prices for farmers while providing premium, traceable agricultural products directly to end users through a transparent, farmer-first supply chain.",
    website: "malnadnaturals.com",
  },
  {
    image: "images/companies/markecha_logo.jpg",
    title: "Markecha",
    description1:
      "We are a leading digital marketing agency helping businesses & professionals build professional online presence, and generate consistent high-quality leads, sales, conversions & customer footfall using strategic digital marketing.",
    description2:
      "We build digital marketing ecosystems that help businesses thrive and scale.",
    description3: "Website | Social Media | Paid Ads | Marketing Funnels",
    website: "markecha.in/",
  },
  {
    image: "images/companies/mv_solutions.jpg",
    title: "M V Solutions",
    description1:
      "Founded in 2005, MV Solutions specializes in ERP implementation using Tally, focusing on statutory compliance such as GST, TDS, payroll, and inventory management.",
    description2:
      "We serve small and medium businesses across Belagavi, Hubli, Dharwad, and Goa, offering secure, browser-based access to critical reports for remote management.",
  },
  // {
  //   image: "images/companies/motocross_logo.jpeg",
  //   title: "Motocross India Private Limited.",
  //   description1:
  //     "Motocross India is an automotive service-tech startup, which aims to become the largest local garage chain in India for two-wheelers.",
  //   website: "www.motocrossindia.in",
  //   mail: "info@motocrossindia.inn",
  //   mobile: "+91 8888222992",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  // {
  //   image: "images/companies/moveonwheels_logo.jpeg",
  //   title: "Move on wheels (India) Private Limited.",
  //   description1:
  //     "Moveonwheels is a service-tech vehicle rental company. Which currently rents out two-wheelers right from commute to superbikes.",
  //   website: "www.Moveonwheels.in",
  //   mail: "info@moveonwheels.in",
  //   mobile: "+91 8762680082",
  // },
  // {
  //   image: "images/companies/nmc_logo.jpeg",
  //   title: "NoeticMinds Consulting",
  //   description1:
  //     "NoeticMinds Consultins is a Belagavi based Knowledge consulting organisation specialising in:",
  //   listItem1: "Technology & Business Development",
  //   listItem2: "Catering to Small & Medium size businesses worldwide",
  //   listItem3: "Focus areas:eCommerce, ITES, Digital content & Marketing",
  //   website: "NoeticMinds.com",
  //   mail: "contact@Noeticminds.com",
  //   mobile: "+91 7738088565",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  // {
  //   image: "images/companies/oust_logo.png",
  //   title: "Oust Labs",
  //   description2:
  //     "A mobile platform for last-mile onboarding, training, and engagement in large geographically distributed organizations.",
  //   website: "oustlabs.com",
  //   mail: "oustlabs.com",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  {
    image: "images/companies/ohms_power.png",
    title: "OHMS Power Solutions",
    description1:
      "Founded in 2018 by Baburao B, OHMS Power Solutions is a Belagavi-based enterprise providing power backup and management solutions.",
    description2:
      "We specialize in the sales, installation, and servicing of industrial-grade UPS systems, servo stabilizers, isolation transformers, and batteries, tailored for commercial and industrial needs.",
    website: "ohmspower.com",
  },
  {
    image: "images/companies/outofbox_logo.png",
    title: "Outofbox Cloud Lab",
    description1:
      "Founded in 2020 by Ajit Patil, Outofbox Cloud is Belagavi’s first public cloud company, providing locally hosted cloud services.",
    description2:
      "We offer scalable, affordable cloud solutions tailored to Indian enterprises, with a focus on data residency and compliance. Our India-hosted infrastructure supports SMEs and public institutions with cost-effective, latency-optimized solutions.",
    website: "outofbox.cloud",
  },
  {
    image: "images/companies/proen.png",
    title: "PROEN Consulting Services Pvt. Ltd.",
    description1:
      "PROEN, a subsidiary of Carvewing Solutions, offers end-to-end Contract Lifecycle Management (CLM) expertise to help organizations automate and manage every step of the contract lifecycle.",
    description2:
      "We specialize in AI/ML-powered automation, data analytics, and PoS systems for AgriTech and Retail, with a focus on regulated industries like healthcare and agriculture.",
    website: "proen.in",
  },
  // {
  //   image: "images/companies/Ezolar_logo.jpg",
  //   title: "Phovoezolar Energy Pvt Ltd (EZOLAR – Easy Solar)",
  //   description2:
  //     "A startup in the Renewable Energy sphere with an aim to digitize the sale of solar projects through our first of its kind marketplace platform (www.ezolar.com). We have executed 6 MWp of solar projects through our EZOLAR platform translating to 25 Crore of Gross Projects Value. We have also developed a fin-tech offering for the financing of solar projects.",
  //   website: "ezolar.com",
  //   mail: "maahir@ezolar.com",
  //   mobile: "+91 9448132233",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  // {
  //   image: "images/companies/playmantis_logo.png",
  //   title: "Playmantis Studio Private Limited",
  //   description2:
  //     "Playmantis Studio Pvt. Ltd. is aimed to develop high-quality games and experiences for the next generation using the latest experiences and technologies like VR, MR, XR and AR however we might also develop games and experiences which supports native Android and iOS phones, Smart TVs, Windows, Linux, and Mac operating systems.",
  //   website: "playmantis.studio",
  //   mail: "shoot@playmantis.studio",
  //   mobile: "+91 8105631983",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  {
    image: "images/companies/reputes.jpg",
    title: "Reputes Business Solutions",
    description1:
      "Founded in 2016 by CEO Supreet Dixit, Reputes Business Solutions is a Belagavi-based SaaS company with a global presence in Ottawa, Canada.",
    description2:
      "We specialize in AI-driven marketing tech to help businesses grow faster and smarter. Our proprietary tool, Amartya AI, powers our performance marketing services, delivering clients an average 10x-15x Return on Ad Spend (ROAS).",
    website: "www.reputes.in",
  },
  {
    image: "images/companies/SenseGiz_logo.jpg",
    title: "SenseGiz Technologies",
    description1:
      "Founded in 2013 by Abhishek Latthe, SenseGiz is an IoT and smart sensor technology company based in Belagavi.",
    description2:
      "We specialize in real-time location, asset tracking, and safety solutions for enterprise, industrial, and defense sectors. Our in-house developed hardware and software systems have been trusted by leaders like BCCI, Maruti Suzuki, ITC, and the Indian Army.",
    website: "sensegiz.com",
  },
  {
    image: "images/companies/samhita.png",
    title: "Samhita Engineering LLP",
    description1:
      "Founded in 2020, Samhita Engineering LLP is based in Sankeshwar, Karnataka. We specialize in aerospace, avionics, automation testing, and safety-critical software compliance.",
    description2:
      "Our flagship product, Engine Suite, is designed for high-stakes environments demanding precision and accountability. We partner with industries like aerospace and automotive to deliver dependable, compliant solutions that drive innovation.",
    website: "www.samhitaengg.com",
  },
  {
    image: "images/companies/sarus_aerospace.png",
    title: "Sarus Aerospace Pvt. Ltd.",
    description1:
      "Founded in 2022 by Rahul Patil, Sarus Aerospace Pvt. Ltd. is a Belagavi-based deep-tech company specializing in indigenous drone development.",
    description2:
      "We focus on high-end, long-endurance VTOL drones and modular multirotor platforms, designed and manufactured in India. Our aim is to innovate in UAVs for defense, agriculture, logistics, and surveying, with a commitment to scalability, performance, and reliability.",
    website: "www.sarusaerospace.in",
  },
  {
    image: "images/companies/shrigeet_solutions.jpg",
    title: "Shrigeet Solutions",
    description1:
      "Founded in 2012 and headquartered in Belagavi, Shrigeet Solutions is a custom software development company specializing in user-friendly, practical solutions for industries, institutions, and businesses.",
    description2:
      "We focus on tailoring technology to real-world applications with a client-first mindset and innovative approach.",
  },
  {
    image: "images/companies/sophon_technologies.png",
    title: "Sophon Technologies",
    description1:
      "Founded in 2024 by Veeresh Ambe, Sophon Technologies is a Belagavi-based firm specializing in automotive embedded systems. ",
    description2:
      "We focus on delivering turnkey software and hardware solutions, aiming to become India’s first homegrown automotive software product company.",
    website: "www.sophontech.in",
  },
  // {
  //   image: "images/companies/shirish_logo.png",
  //   title: "Shirish Productions",
  //   description2:
  //     "Shirish Productions is a professional Web Development company that was established in the year 2010 by Shirish Chincholimath in Belagavi. Driven by high morals and ethics, they endeavor to be a pioneer in the Information Technology sector/industry and have even served in numerous esteemed projects internationally.",
  //   website: "shirish.productions",
  //   mail: "mail@shirishproductions.com",
  //   mobile: "+91 8073212071",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  // {
  //   image: "images/companies/ShreshtaIT_Logo.jpg",
  //   title: "Shreshta IT Technologies Pvt. Ltd.",
  //   description1:
  //     "Shreshta IT is an InfoSec company (Blue team) specializing in Network Forensics, Digital Forensics, and Incident Response (DFIR).",
  //   website: "shreshtait.com",
  //   mail: "info@shreshtait.com",
  //   mobile: "+91 9886637820",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  // {
  //   image: "images/companies/starnet_logo.jpg",
  //   title: "StarNet Computer",
  //   description1:
  //     "Distributor | Dealer | Retailer for IT Hardware/Software Products like From DELL | HP | Microsoft -Surface | EPSON | BROTHER | ASUS | CANON Etc.",
  //   website: "starnetBelagavi.com",
  //   mail: "info@starnetBelagavi.com",
  //   mobile: "+91 9986506184",
  //   // sx: "radial-gradient(circle, rgba(179,199,237,1) 0%, rgba(33,143,208,1) 46%, rgba(4,166,170,1) 85%)",
  // },
  {
    image: "images/companies/theta_dynamics.png",
    title: "Theta Dynamics Pvt. Ltd.",
    description1:
      "Founded in 2024 by Gajendra Deshpande and Pradosh Hegde, Theta Dynamics is a Belagavi-based tech company specializing in cybersecurity, software development, and corporate training. ",
    description2:
      "We are members of NASSCOM and the Data Security Council of India, contributing to India’s cybersecurity ecosystem from North Karnataka. We are focused on developing innovative, AI-driven solutions and expanding collaborations with universities for R&D.",
    website: "www.thetadynamics.com",
  },
  {
    image: "images/companies/Vayavya_Logo.jpg",
    title: "Vayavya Labs Pvt. Ltd.",
    description1:
      "Vayavya Labs, a deep-tech company, specializes in embedded software design and development for semiconductor companies in sectors like consumer electronics, communication systems, and automotive.",
    description2:
      "Trusted by top global clients, we’re backed by 11 US patents, showcasing our innovation in real-world deployments.",
    website: "www.vayavyalabs.com",
  },
  {
    image: "images/companies/vigilomics.jpg",
    title: "Vigilomics Biosciences Pvt. Ltd.",
    description1:
      "Founded in 2024, Vigilomics is a Belagavi-based health tech company pioneering AI-augmented canine olfaction for early cancer detection.",
    description2:
      "Our proprietary solution combines the olfactory abilities of trained dogs with AI and machine learning to offer a non-invasive, accurate cancer screening method. We aim to revolutionize cancer diagnostics in India through innovation in biotechnology, data science, and clinical research.",
    website: "www.vigilomics.com",
  },
  {
    image: "images/companies/Wetrunk_Logo.png",
    title: "WeTrunk IT Solutions Pvt. Ltd.",
    description1:
      "Founded in 2016 by Sachin Kulgod, WeTrunk is a Belagavi-based product-first tech company focused on building SaaS platforms for niche sectors.",
    description2:
      "With a lean team, we develop scalable and impactful solutions for underserved markets, especially mid-sized businesses and cooperatives.",
    website: "wetrunk.in",
  },
  {
    image: "images/companies/zenigma.png",
    title: "Zenigma Labs Pvt. Ltd.",
    description1:
      "Founded in 2025 by Siddaling Basavaraj Latti, Zenigma Labs is a Belagavi-based IT services company driving Industry 4.0 transformation.",
    description2:
      "We help MSMEs and manufacturers modernize through smart, scalable, and custom-built digital solutions.",
  },
];
